import { defineStore } from 'pinia';
import { useShowStore } from './show';
import { updateShowType } from '@/helpers/eventsHelper';
export const useUndoManagerStore = defineStore('undoManager', {
	state: () => ({
		undo_stack: [],
		redo_stack: [],
		temp_undo_group_stack: [],
		is_adding_to_group: false,
	}),
	getters: {
		can_undo: (state) => state.undo_stack.length > 0,
		can_redo: (state) => state.redo_stack.length > 0,
	},
	actions: {
		addAction(value_changed, previous_value, perform_change = this.defaultCallback) {
			const action = {
				value: JSON.parse(JSON.stringify(value_changed)),
				previous_value: JSON.parse(JSON.stringify(previous_value)),
				perform_change,
			};
			if (this.is_adding_to_group) {
				this.temp_undo_group_stack.push(action);
			} else {
				this.undo_stack.push(action);
			}
		},
		undo() {
			if (!this.undo_stack.length) return;
			const show_store = useShowStore();

			const current_undo_event = this.undo_stack.pop();
			console.log('[EVS-981_CC_DEBUG] undo APPLY', {
				is_group: current_undo_event?.is_group === true,
				group_action_count: current_undo_event?.is_group === true ? current_undo_event?.actions?.length : undefined,
				undo_stack_remaining: this.undo_stack.length,
				redo_stack_remaining: this.redo_stack.length,
			});
			if (current_undo_event.is_group == true) {
				const redo_group = {
					is_group: true,
					actions: [],
				};
				for (const action of current_undo_event.actions.reverse()) {
					action.perform_change(action.previous_value);
					redo_group.actions.push(action);
				}
				redo_group.actions.reverse(); // in order to maintain the order of the actions in which they should be undone, so that they can be redone in the correct order
				this.redo_stack.push(redo_group);
			} else {
				current_undo_event.perform_change(current_undo_event.previous_value);
				this.redo_stack.push(current_undo_event);
			}
			console.log('[EVS-981_CC_DEBUG] undo APPLY done', {
				events_summary_first_500: (show_store?.active_show?.events || []).slice(0, 500).map((ev) => ({
					event_id: ev?.event_id,
					channel: ev?.channel,
					cue: ev?.cue,
					cue_auto_incremented: ev?.cue_auto_incremented,
				})),
			});

			if (show_store.active_show) {
				show_store.active_show.show_type = updateShowType(show_store.active_show.events);
			}
			show_store.toggle_waveform_reset = !show_store.toggle_waveform_reset;
			show_store.setChangeMadeToTrue();
		},
		redo() {
			if (!this.redo_stack.length) return;
			const show_store = useShowStore();

			const current_redo_event = this.redo_stack.pop();
			console.log('[EVS-981_CC_DEBUG] redo APPLY', {
				is_group: current_redo_event?.is_group === true,
				group_action_count: current_redo_event?.is_group === true ? current_redo_event?.actions?.length : undefined,
				undo_stack_remaining: this.undo_stack.length,
				redo_stack_remaining: this.redo_stack.length,
			});
			if (current_redo_event.is_group == true) {
				const undo_group = {
					is_group: true,
					actions: [],
				};
				for (const action of current_redo_event.actions) {
					action.perform_change(action.value);
					undo_group.actions.push(action);
				}
				this.undo_stack.push(undo_group);
			} else {
				current_redo_event.perform_change(current_redo_event.value);
				this.undo_stack.push(current_redo_event);
			}
			console.log('[EVS-981_CC_DEBUG] redo APPLY done', {
				events_summary_first_500: (show_store?.active_show?.events || []).slice(0, 500).map((ev) => ({
					event_id: ev?.event_id,
					channel: ev?.channel,
					cue: ev?.cue,
					cue_auto_incremented: ev?.cue_auto_incremented,
				})),
			});

			if (show_store.active_show) {
				show_store.active_show.show_type = updateShowType(show_store.active_show.events);
			}
			show_store.toggle_waveform_reset = !show_store.toggle_waveform_reset;
			show_store.setChangeMadeToTrue();
		},
		beginUndoGrouping() {
			this.is_adding_to_group = true;
		},
		endUndoGrouping() {
			this.undo_stack.push({
				is_group: true,
				actions: this.temp_undo_group_stack,
			});
			this.temp_undo_group_stack = [];
			this.is_adding_to_group = false;
		},
		cancelUndoGrouping() {
			this.temp_undo_group_stack = [];
			this.is_adding_to_group = false;
		},
		clearStack() {
			this.undo_stack = [];
			this.redo_stack = [];
			this.temp_undo_group_stack = [];
			this.is_adding_to_group = false;
		},
		defaultCallback(events) {
			const show_store = useShowStore();
			events.forEach((event) => {
				const index = show_store.active_show.events.findIndex((matching_event) => matching_event.event_id === event.event_id);
				if (index !== -1) {
					show_store.active_show.events[index] = JSON.parse(JSON.stringify(event));
				}
			});
		},
	},
});
